<template>
    <div>
        <el-form ref="form" :rules="rules" :model="form" label-width="100px">
            <el-form-item label="一级标题:" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="关于博客:" prop="content">
                <quill-editor v-model="form.content" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="onSubmit('form')">编辑</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                title: '',
                content: '',
            },
            rules: {},
        };
    },
    methods: {
        async onSubmit(formName) {
            const { data: res } = await this.$axios.post(
                "/about/editAbout",
                this.form
            );
            console.log(res);
            if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
            return this.$message.success(res.meta.msg);
        },
        async getAbout() {
            const { data: res } = await this.$axios.post("/about");
            console.log(res);
            this.form = res.data;
        },
    },
    created() {
        this.getAbout();
    }
}
</script>

<style lang="less">
.el-input,
.quill-editor {
    max-width: 800px;
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/about/about.vue